import React, { useState } from "react";
import meta_theme from "./geograph/metadatas/meta_theme_20260116";
import { GeographHeader } from "./geograph/panels/geographHeader";
import logo1 from "./img/select1.webp";
import logo2 from "./img/select2.webp";
import logo3 from "./img/select3_20241208.webp";
import logo4 from "./img/select4.webp";
import logo5 from "./img/select5.webp";
import logo6 from "./img/select6.webp";
import logo7 from "./img/select7.webp";
// import logo8 from "./img/select8.webp";
import {
  Modalchiriteki,
  Modalchuugaku,
  Modalsdgs,
  Modalsougou,
  Modalsyougaku,
  Modalsyutten,
  Modaltankyu,
} from "./selectmodal";
import { GeographFooter } from "./geograph/panels/geographFooter";


const Panel = ({ img, title, subtitle, description, themenum }) => {
  return (
    <>
      <div
        className="
          cursor-pointer
          bg-white
          shadow-md
          h-[40vh]
          rounded-3xl
          flex flex-col
          justify-around
          items-center
          overflow-hidden
          sm:flex-row sm:h-[18vh]
          lg:w-[45vw] mx-[1vw] my-[1vh]
        "
      >
        <img
          className="h-1/2 w-full sm:h-full sm:w-5/12 object-cover"
          src={img}
          alt="panel"
        />
        <div
          className="
            flex-1
            w-full
            flex flex-col
            items-baseline
            justify-around
            h-1/2
            pl-6
            sm:h-full sm:items-baseline sm:w-1/2
          "
        >
          <div className="flex flex-col justify-start items-baseline">
            <h1 className="text-4xl font-normal mb-0 text-gray-600 font-sans">
              {title}
            </h1>
            <span className="text-xs text-indigo-300 mt-0">{subtitle}</span>
          </div>
          <p className="text-xs text-gray-500 w-4/5">{description}</p>
          <div className="w-full flex justify-between items-center">
            <h1 className="font-bold text-gray-500">{themenum}</h1>
            <button className="bg-gray-700 mr-5 text-white px-3 py-1 rounded-sm shadow-md">
              選択
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export const Select = () => {
  const [showsdgs, setShowsdgs] = useState(false);
  const [showsougou, setShowsougou] = useState(false);
  const [showtankyu, setShowtankyu] = useState(false);
  const [showchiriteki, setShowchiriteki] = useState(false);
  const [showsyutten, setShowsyutten] = useState(false);
  const [showchuugaku, setShowchuugaku] = useState(false);
  const [showsyougaku, setShowsyougaku] = useState(false);

  return (
    <>
      <div className="absolute z-30 font-mono text-black w-full h-screen bg-blue-100">
        <div className=" z-30">
          <GeographHeader />
        </div>
        <div className="flex min-h-[8vh] mt-16 text-base md:text-2xl text-left w-full text-black text-extrabold bg-gradient-to-r from-cyan-200 to-blue-400 hover:bg-gradient-to-bl focus:ring-4 focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium px-5 py-2.2">
          <div className="flex items-center">
            テーマ選択：「見える化」したいテーマを選びましょう
          </div>
          <div className="grow"></div>
          <div className="flex items-center">
            <a
              // href="/tgsl/全てのテーマ"
              href={`/tgsl/全てのテーマ${window.location.search}`}
              className="text-xs md:text-xl lg:text-2xl"
            >
              <button className="bg-gray-700 mr-5 text-white px-3 py-2 rounded-sm shadow-md">
                全てのテーマ
              </button>
            </a>
          </div>
        </div>

        <div className="lg:flex lg:flex-wrap w-full min-h-[76vh]">
          <div onClick={() => setShowsdgs(true)}>
            <Panel
              img={logo1}
              title={meta_theme[0].genre}
              subtitle={meta_theme[0].midashi_english}
              description={meta_theme[0].midashi_japanese}
              themenum={meta_theme[0].count}
              show={showsdgs}
              setShow={setShowsdgs}
            />
          </div>

          <div onClick={() => setShowsougou(true)}>
            <Panel
              img={logo2}
              title={meta_theme[1].genre}
              subtitle={meta_theme[1].midashi_english}
              description={meta_theme[1].midashi_japanese}
              themenum={meta_theme[1].count}
              show={showsougou}
              setShow={setShowsougou}
            />
          </div>

          <div onClick={() => setShowtankyu(true)}>
            <Panel
              img={logo3}
              title={meta_theme[2].genre}
              subtitle={meta_theme[2].midashi_english}
              description={meta_theme[2].midashi_japanese}
              themenum={meta_theme[2].count}
              show={showtankyu}
              setShow={setShowtankyu}
            />
          </div>

          <div onClick={() => setShowchuugaku(true)}>
            <Panel
              img={logo6}
              title={meta_theme[3].genre}
              subtitle={meta_theme[3].midashi_english}
              description={meta_theme[3].midashi_japanese}
              themenum={meta_theme[3].count}
              show={showchuugaku}
              setShow={setShowchuugaku}
            />
          </div>

          <div onClick={() => setShowsyougaku(true)}>
            <Panel
              img={logo7}
              title={meta_theme[4].genre}
              subtitle={meta_theme[4].midashi_english}
              description={meta_theme[4].midashi_japanese}
              themenum={meta_theme[4].count}
              show={showsyougaku}
              setShow={setShowsyougaku}
            />
          </div>

          <div onClick={() => setShowchiriteki(true)}>
            <Panel
              img={logo4}
              title={meta_theme[5].genre}
              subtitle={meta_theme[5].midashi_english}
              description={meta_theme[5].midashi_japanese}
              themenum={meta_theme[5].count}
              show={showchiriteki}
              setShow={setShowchiriteki}
            />
          </div>

          <div onClick={() => setShowsyutten(true)}>
            <Panel
              img={logo5}
              title={meta_theme[6].genre}
              subtitle={meta_theme[6].midashi_english}
              description={meta_theme[6].midashi_japanese}
              themenum={meta_theme[6].count}
              show={showsyutten}
              setShow={setShowsyutten}
            />
          </div>
          {/* <a href="/double" className="block">
            <Panel
              img={logo8}
              title={meta_theme[7].genre}
              subtitle={meta_theme[7].midashi_english}
              description={meta_theme[7].midashi_japanese}
              themenum={meta_theme[7].count}
              show={showsyutten}
              setShow={setShowsyutten}
            />
          </a> */}
        </div>

        <Modalsdgs show={showsdgs} setShow={setShowsdgs} />
        <Modalsougou show={showsougou} setShow={setShowsougou} />
        <Modaltankyu show={showtankyu} setShow={setShowtankyu} />
        <Modalchiriteki show={showchiriteki} setShow={setShowchiriteki} />
        <Modalchuugaku show={showchuugaku} setShow={setShowchuugaku} />
        <Modalsyougaku show={showsyougaku} setShow={setShowsyougaku} />
        <Modalsyutten show={showsyutten} setShow={setShowsyutten} />

        {/* <div className="bg-blue-300 min-h-[4vh] text-base">
© 2022 <a href="https://www.teikokushoin.co.jp/" target="_blank" rel="noopener noreferrer">帝国書院</a> ＆ <a href="https://www.kashika.or.jp/geograph/" target="_blank" rel="noopener noreferrer">都市構造可視化推進機構</a>
</div> */}

        <div className="absolute z-20 min-w-full font-bold text-sm lg:text-base text-gray-100 bg-gradient-to-r from-blue-600 to-blue-800  focus:ring-4 focus:ring-lime-200 dark:focus:ring-teal-700 py-1 text-center h-8">
          <GeographFooter />
          {/* {""} */}
          {/* <a
            href="https://www.teikokushoin.co.jp/"
            target="_blank"
            rel="noopener noreferrer"
          >
            帝国書院
          </a>{" "}
          ＆{" "}
          <a
            href="https://www.kashika.or.jp/geograph/"
            target="_blank"
            rel="noopener noreferrer"
          >
            都市構造可視化推進機構
          </a> */}
        </div>
      </div>
    </>
  );
};
